var $ = jQuery.noConflict();

/* Slick Options */
  const prevArrow = '<button type="button" class="slick-big-arrow slick-prev"><span class="screen-reader-text">Previous</span></button>';
  const nextArrow = '<button type="button" class="slick-big-arrow slick-next"><span class="screen-reader-text">Next</span></button>';

  const handleKeypressADA = function() {
    const keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') return;
    $(this).trigger('click');
  };


  let windowWidth = $(window).width(),
      windowHeight = $(window).height(),
      windowScrollHeight = 0,
      mobileBreakpoint = 768,
      isMobile = ( windowWidth <= mobileBreakpoint );

$(document).ready(function(){

  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;

  if ( $('.member-company-search-header').length ) {
    $('.member-company-search-header button').click(function(e){
      if ( $('.member-company-search-header input').val() == '' ) {
        e.preventDefault();
        $('.member-company-search-header input').focus();
      }
    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  if ( $('.resource-feed__taxfilter').length ) {
    $('.resource-feed__taxfilter').each(function(){
      const toggle = $(this).find('.resource-feed__taxfilter-toggle');
      const list = $(this).find('.resource-feed__taxfilter__list');

      toggle.on('click', function(){
        list.slideToggle();
        $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
      }).on('keypress', function(){
        $(this).trigger('click');
      });
    });

    let date = false;
    const checkboxes = $(this).find('.resource-feed__taxfilter__checkbox-input');
    const tagCheckboxes = $(this).find('#taxlist-member_tag .resource-feed__taxfilter__checkbox-input');
    const typeCheckboxes = $(this).find('#taxlist-member_file_type .resource-feed__taxfilter__checkbox-input');

    const updateFilters = () => {
      if ( $('.resource-feed__filters-submit').length == 0 ) {
        let anyShown = false;
        let tags = [];
        let types = [];

        let tagString = [];
        let typeString = [];


        tagCheckboxes.each(function(){
          if ( $(this).is(':checked') ) {
            tags.push( $(this).attr('name').split('-').pop() );
            tagString.push( $(this).next().text().trim() );
          }
        });

        $('.resource-feed__taxfilter-toggle[aria-controls="taxlist-member_tag"]').find('.cur-val').text( tagString.join(', ') );
        if ( tagString.length > 0 ) {
          $('.resource-feed__taxfilter-toggle[aria-controls="taxlist-member_tag"]').find('.label').addClass('screen-reader-text');
        } else {
          $('.resource-feed__taxfilter-toggle[aria-controls="taxlist-member_tag"]').find('.label').removeClass('screen-reader-text');
        }

        typeCheckboxes.each(function(){
          if ( $(this).is(':checked') ) {
            types.push( $(this).attr('name').split('-').pop() );
            typeString.push( $(this).next().text().trim() );
          }
        });

        $('.resource-feed__taxfilter-toggle[aria-controls="taxlist-member_file_type"]').find('.cur-val').text( typeString.join(', ') );
        if ( typeString.length > 0 ) {
          $('.resource-feed__taxfilter-toggle[aria-controls="taxlist-member_file_type"]').find('.label').addClass('screen-reader-text');
        } else {
          $('.resource-feed__taxfilter-toggle[aria-controls="taxlist-member_file_type"]').find('.label').removeClass('screen-reader-text');
        }

        $('.resource-entry, .tag-entry').hide();
        $('.resource-entry').each(function(){
          let passes = true;
          if ( date ) {
            const thisDate = new Date(parseInt($(this).data('time') ) * 1000);
            if ( thisDate < date ) {
              passes = false;
            }
          }

          const resourceTags = $(this).data('tags');
          if ( tags.length > 0 ) {
            let passesTags = false;
            for ( let i = 0; i < tags.length; i++ ) {
              if ( resourceTags.includes(parseInt(tags[i])) ) {
                passesTags = true;
              }
            }

            passes = passes && passesTags;
          }

          const resourceTypes = $(this).data('types');
          if ( types.length > 0 ) {
            let passesTypes = false;
            for ( let i = 0; i < types.length; i++ ) {
              if ( resourceTypes.includes(parseInt(types[i])) ) {
                passesTypes = true;
              }
            }

            passes = passes && passesTypes;
          }

          if ( passes ) {
            $(this).fadeIn().next().fadeIn();
            anyShown = true;
          }
        });

        if ( anyShown == false ) {
          $('.resource-feed__noresults').show();
        } else {
          $('.resource-feed__noresults').hide();
        }
      }
    };

    const radios = $(this).find('input[name="resource-feed-date"]');
    radios.on('change', function() {
      date = new Date(parseInt($(this).val()) * 1000 );
      updateFilters();
      const parent = $(this).closest('.resource-feed__taxfilter');
      const toggle = $(parent).find('.resource-feed__taxfilter-toggle');
      const list = $(parent).find('.resource-feed__taxfilter__list');
      list.slideUp();
      toggle.attr('aria-expanded', 'false');
      $('.resource-feed__taxfilter-toggle[aria-controls="date-filters"]').find('.cur-val').text( $(this).next().text().trim() );
      $('.resource-feed__taxfilter-toggle[aria-controls="date-filters"]').find('.label').addClass('screen-reader-text');
    });

    checkboxes.on('change', function(){
      updateFilters();
    });
  }

  if ( $('.member-company-initiative-list__mobiletoggle').length ) {
    $('.member-company-initiative-list__mobiletoggle').on('click', function(){
      $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true' );
      $('.member-company-initiative-list').slideToggle(1000);
    }).on('keypress', function(){
      $(this).trigger('click');
    });
  }

  if ( $('.resource-tag-list__item button').length ) {
    $('.resource-tag-list__item button').on('click', function(){
      const target = $('input[name="term-' + $(this).data('termid') + '"]');
      target.prop('checked', true);
      target.trigger('change');
    });
  }

  if ( $('.resource-videotrigger').length ) {
    $('.resource-videotrigger').each(function(){
      const src = $(this).data('src');
      $(this).on('click', function(){
        const thisRef = this;

        const modal = document.createElement('div');
        modal.classList.add('resource-video-modal');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-label', $(this).text());

        const dismiss = document.createElement('button');
        dismiss.classList.add('resource-video-modal__dismiss');
        const dismissText = document.createElement('span');
        dismissText.classList.add('screen-reader-text');
        dismissText.textContent = 'Dimsiss video modal';
        dismiss.appendChild(dismissText);
        modal.appendChild(dismiss);

        const player = document.createElement('video');
        const source = document.createElement('source');
        source.setAttribute('src', src);
        source.setAttribute('type', 'video/' + ( src.split('.').pop() ));
        if ( this.hasAttribute('data-poster') ) {
          player.setAttribute('data-poster', $(this).attr('data-poster'));
        }
        player.appendChild(source);
        modal.appendChild(player);

        const plyrObj = new Plyr(player, {
          controls: ['play', 'progress', 'current-time', 'mute', 'volume', 'settings', 'fullscreen']
        });

        $(modal).on('keydown', function(e){
          if ( e.key == 'Escape' ) {
            $(dismiss).click();
          }
        });

        $(dismiss).on('click', function() {
          $(modal).fadeOut(500, function(){
            $(modal).remove();
            $(thisRef).focus();
          });
        }).on('keypress', function() {
          $(this).trigger('click');
        });

        $(modal).hide();
        document.querySelector('body').appendChild(modal);
        $(modal).fadeIn(500, function(){
          $(modal).find('.plyr').focus();
          plyrObj.play();
        });
      }).on('keypress', function(){
        $(this).trigger('click');
      });
    });
  }




  $('.site-header__hamburger').click(function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $('body').toggleClass('nav-open');
    $('.site-header__pull-out').toggleClass('active');
    $('.menu-item-has-children').removeClass('active');
    $('body').removeClass('noscroll');
  }).keypress(function(){
    $(this).trigger('click');
  })

  $('.site-header__pull-out li.menu-item-has-children > a').click(function(e){
    e.preventDefault();
    $('.site-header__pull-out li.menu-item-has-children').removeClass('active');
    $(this).parent().addClass('active');
    $('body').addClass('noscroll');
  }).keypress(function(){
    $(this).trigger('click');
  });

  if ( $('.sub-menu.initiatives').length ) {
    if ( $('.sub-menu.initiatives').isVScrollable() ) {
      $('.sub-menu.initiatives').addClass('can-scroll');
      $('.sub-menu.initiatives').scroll(function(e){
        if ( $(this).scrollTop() <= 0 ) {
          $(this).removeClass('scrolled');
        } else {
          $(this).addClass('scrolled');
        }
      });
    }

    $(window).resize(function(){
      if ( $('.sub-menu.initiatives').isVScrollable() ) {
        $('.sub-menu.initiatives').addClass('can-scroll');
      } else{
        $('.sub-menu.initiatives').removeClass('can-scroll');
      }
    });
  }
  
  
  if ( $('.blog-toggle').length ) {
    $('.blog-toggle').click(function(e){
      e.preventDefault();
      $('.blog-container').toggleClass('single');
      if ( $('.blog-container').hasClass('single') ) {
        $(this).text( $(this).data('singlecopy') );
        $(this).attr( 'href', $(this).data('bloglink') );
        ajaxPushState($(this).attr('href'), $(this).data('title'));
      } else {
        $(this).text( $(this).data('feedcopy') );
        $(this).attr( 'href', $(this).data('postlink') );
        ajaxPushState( $(this).data('bloglink'), 'Blog' );
      }
    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  if ( $('.blog-single, .blog-left').length ) {
    if ( $(window).width() <= 767 ) {
      console.log("updating");
      $('.blog-single, .blog-left').css('top', ($('.blog-right__sticky').outerHeight() + 96) + 'px');
    }
    $(window).resize(function(){
      if ( $(window).width() <= 767 ) {
        $('.blog-single, .blog-left').css('top', ($('.blog-right__sticky').outerHeight() + 96) + 'px');
      } else {
        $('.blog-single, .blog-left').css('top', '');
      }
    });
  }

  if ( $('.hp-carousel').length && $('.hp-carousel__slide').length ) {
    $('.hp-carousel__images').slick({
      arrows: false,
      fade: true
    });
    $('.hp-carousel').slick({
      'appendArrows': $('.hp-carousel__controls'),
      'prevArrow': '<button type="button" class="slick-prev"><span class="screen-reader-text">Previous</span></button>',
      'nextArrow': '<button type="button" class="slick-next"><span class="screen-reader-text">Next</span></button>',
      'asNavFor': $('.hp-carousel__images'),
      'fade': true
    });

    $('.hp-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      console.log(nextSlide);
      $('.hp-carousel__toc-item').removeClass('active');
      $('.hp-carousel__toc-item').eq(nextSlide).addClass('active');
    });

    $('.hp-carousel__toc-item a').on('click', function(e){
      e.preventDefault();
      $('.hp-carousel').slick('slickGoTo', $('.hp-carousel__toc-item').index($(this).parent()));
    }).on('keypress', function(){
      $(this).trigger('click');
    })
  }

  if ( $('.filter-dropdown').length ) {
    $('.filter-dropdown').prettyDropdown({
      customClass: 'event-filters__dropdown-styled1',
      hoverIntent: -1,
      classic: true
    });
  }
  // ********************** BLOG SEARCH FILTER CATEGORY
  if ( $('.event-filters__dropdown').length ) {
    $('.event-filters__dropdown').prettyDropdown({
      customClass: 'event-filters__dropdown-styled',
      hoverIntent: -1,
      classic: true
    });
  }
  
    // ********************** BLOG SEARCH FILTER DATE
    if ( $('.event-filters__dropdown-date').length ) {
      $('.event-filters__dropdown-date').prettyDropdown({
        customClass: 'event-filters__dropdown-styled',
        hoverIntent: -1,
        classic: true
      });
    }
  
    // ******************** BLOG SEARCH FILTER CATEGORY ARTICLE CARDS ADD REMOVE CLASS
    var arrayOfFilters = {cat:"all",datenumber:1000000000};
  
    $("#filter-dropdown").change(function(){
        var selectedPost = $(this).children("option:selected").val();
        arrayOfFilters.cat = $(this).children("option:selected").val();
        filterBlogPosts(arrayOfFilters)
  
    });
  
    // ******************** BLOG SEARCH FILTER DATE ARTICLE CARDS ADD AND REMOVE CLASS
    $("#filter-dropdown-date").change(function(){
      var target = $(this).val();
      arrayOfFilters.datenumber = $(this).val();
      filterBlogPosts(arrayOfFilters);
    });
  
    function filterBlogPosts(arrayOfFilters){
      // console.log(arrayOfFilters);
      //hide all posts
    $(".blog-entry").addClass('inactive');
    $(".blog-entry").removeClass('active');
    //show all the category posts from the select by adding the active class
    $(".has-term-"+arrayOfFilters.cat).addClass('active');
    $(".has-term-"+arrayOfFilters.cat).removeClass('inactive');
    //lookp through all the active posts
      $(".active").each(function(){
        // console.log(arrayOfFilters.datenumber);
        //if the date number is the active post is greater than the chosen date...
        if($(this).data("number") > arrayOfFilters.datenumber){
          // console.log("changing");
          //hide the post
        $(this).addClass('inactive');
        $(this).removeClass('active');
      }
  
      });
  
    }

  /* ARCHIVE BLOCK SCRIPTS */
  if ( $('.archive-block').length ) {
    $('.archive-block').each(function(){
      let ajaxIsLoading = false;
      const archiveBlock = $(this);
      const archiveFeed = $(this).find('.archive-block__feed');
      const archivePagination = $(this).find('.archive-block__pagination-container');
      const isInfinite = $(this).hasClass('is-infinite-scroll');

      const archiveFilterForm = $(this).find('.archive-block__header');
      const archiveSortInputs = $(this).find('.archive-block__sort-radio-input');
      const archiveSearchInput = $(this).find('.archive-block__search-input');
      const archiveSearchConfirm = $(this).find('.archive-block__search-confirm');

      const archiveFilterGroups = $(this).find('.archive-block__filter');


      const base = $(this).data('baseurl');
      let currentURL = $(this).data('currenturl');
      const initPage = $(this).data('page');
      const postType = $(this).data('posttype');
      const exclude = $(this).data('exclude');
      const initMaxPages = $(this).data('maxpages');

      let updateArchive = () => {

      };

      let stateObj = {
        base: base,
        url: currentURL,
        page: initPage,
        sort: 'default',
        postType: postType,
        search: false,
        exclude: exclude,
        filters: {},
        maxPages: initMaxPages
      };

      if ( this.hasAttribute('data-postsper') ) {
        stateObj.postsPerPage = $(this).data('postsper');
      }

      if ( this.hasAttribute('data-cardargs') ) {
        stateObj.cardArgs = $(this).data('cardargs');
      }

      const updateURLFromFilters = () => {
        const baseurl = base[0] === '/' ? window.location.protocol + base : base;
        const url = new URL(baseurl);
        if ( stateObj.sort !== 'default' ) {
          url.searchParams.append('sort', 'sort-' + stateObj.sort);
        }

        if ( stateObj.search !== false ) {
          url.searchParams.append('search', stateObj.search);
        }

        if ( Object.keys(stateObj.filters).length ) {
          for ( const filterType in stateObj.filters ) {
            if ( Array.isArray(stateObj.filters[filterType]) ) {
              url.searchParams.append(filterType, stateObj.filters[filterType].join(','));
            } else {
              url.searchParams.append(filterType, stateObj.filters[filterType]);
            }
          }
        }

        stateObj.url = url.toString();
        stateObj.page = 1;

        updateArchive();
      };

      if ( archiveFilterGroups.length ) {
        $(archiveFilterGroups).each(function() {
          const inputs = $(this).find('input');

          const mobileToggle = $(this).find('.archive-block__filter-toggle');
          const mobileDropdown = $(this).find('.archive-block__filter-list');

          mobileToggle.on('click', function(){
            $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true' );

            if ( $(this).attr('aria-expanded') == 'true' ) {
              $(mobileDropdown).css({
                'visibility': 'visible',
                'pointer-events': 'auto'
              });
              gsap.to(mobileDropdown, {
                clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
              });
            } else {
              gsap.to(mobileDropdown, {
                clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                onComplete: function(){
                  $(mobileDropdown).css({
                    'visibility': 'hidden',
                    'pointer-events': 'none'
                  });
                }
              })
            }
          }).on('keypress', handleKeypressADA);

          $(inputs).each(function(){
            const name = $(this).attr('name');
            const type = $(this).attr('type');
            const val = $(this).attr('value');

            if ( $(this).is(':checked') ) {
              const label = $(this).siblings('.archive-block__filter-input__label').get(0);

              if ( type === 'radio' ) {
                stateObj.filters[ name ] = val;
              } else {
                if ( stateObj.filters.hasOwnProperty(name) ) {
                  stateObj.filters[ name ].push( val );
                } else {
                  stateObj.filters[ name ] = [ val ];
                }
              }
            }

            $(this).on('change', function(){
              if ( $(this).is(':checked') ) {
                const label = $(this).siblings('.archive-block__filter-input__label').get(0);
                $(mobileToggle).find('.archive-block__filter-toggle__current').text( label.textContent );

                if ( type === 'radio' ) {
                  stateObj.filters[ name ] = val;
                } else {
                  stateObj.filters[ name ].push( val );
                }
              } else if ( type === 'checkbox' ) {
                stateObj.filters[ name ] = stateObj.filters[name].filter( e => e !== val );
              }
              updateURLFromFilters();

              $(mobileToggle).attr('aria-expanded', 'false');
              gsap.to(mobileDropdown, {
                clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
                onComplete: function(){
                  $(mobileDropdown).css({
                    'visibility': 'hidden',
                    'pointer-events': 'none'
                  });
                }
              });
            });
          });
        });
      }

      if ( archiveSortInputs.length ) {
        const toggle = $(this).find('.archive-block__sort-toggle');
        const dropdown = $(this).find('.archive-block__sort-dropdown');
        const toggleHint = $(toggle).find('.archive-block__sort-toggle__current');

        const toggleDropdown = (state) => {
          if ( state ) {
            $(dropdown).css({
              'visibility': 'visible',
              'pointer-events': 'auto'
            });

            gsap.to(dropdown, {
              clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)'
            });
          } else {
            gsap.to(dropdown, {
              clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
              onComplete: function(){
                $(dropdown).css({
                  'visibility': 'hidden',
                  'pointer-events': 'none'
                });
              }
            });
          }
        };

        $(toggle).on('click', function(){
          const oldState = $(this).attr('aria-expanded') == 'true';
          $(this).attr('aria-expanded', oldState ? 'false' : 'true');
          toggleDropdown(!oldState);
        }).on('keypress', handleKeypressADA);

        if ( $('.archive-block__sort-radio-input:checked' ).length ) {
          stateObj.sort = $('.archive-block__sort-radio-input:checked' ).data('sortkey');
        }

        $(archiveSortInputs).on('change', function(){
          stateObj.sort = $('.archive-block__sort-radio-input:checked' ).data('sortkey');
          $(toggle).attr('aria-expanded', 'false');
          toggleDropdown(false);
          updateURLFromFilters();
          $(toggleHint).text( $(this).next().text() );
        });
      }

      if ( archiveSearchInput.length ) {
        if ( archiveSearchInput.val() !== '' ) {
          stateObj.search = archiveSearchInput.val();
        }
      }

      if ( archiveSearchConfirm.length ) {
        archiveSearchConfirm.on('click', function(){
          const searchQuery = archiveSearchInput.val();
          if ( searchQuery !== '' ) {
            if ( stateObj.search !== searchQuery ) {
              stateObj.search = searchQuery;
            }

            updateURLFromFilters();
          } else {
            if ( stateObj.search !== false ) {
              stateObj.search = false;
              updateURLFromFilters();
            }
          }
        }).on('keypress', handleKeypressADA);
      }

      if ( archiveFilterForm.length ) {
        archiveFilterForm.on('submit', function(e){
          e.preventDefault();
          if ( archiveSearchConfirm.length ) {
            archiveSearchConfirm.trigger('click');
          }
        });
      }

      $(archivePagination).on('click', 'a', function(e){
        e.preventDefault();
        if ( ajaxIsLoading === false ) {
          const url = $(e.target).attr('href');
          let page = 1;
          const urlparts = url.split('?')[0].split('/');
          if ( urlparts[ urlparts.length - 1 ] != '' ) {
            const parsed = parseInt( urlparts[urlparts.length - 1] );
            if ( !isNaN(parsed) ) {
              page = parsed;
            }
          }

          stateObj.url = url;
          stateObj.page = page;

          updateArchive();
        }
      }).on('keypress', 'a', function(e){
        e.preventDefault();
        $(this).trigger('click');
      });

      if ( isInfinite ) {
        if ( stateObj.page < stateObj.maxPages ) {
          $('#colophon').hide();
        }

        ScrollTrigger.create({
          trigger: this,
          start: 'bottom bottom',
          end: 'bottom top',
          onEnter: () => {
            console.log(stateObj);
            if ( stateObj.page < stateObj.maxPages && !ajaxIsLoading ) {
              stateObj.page++;
              stateObj.url = stateObj.base + 'page/' + stateObj.page;
              updateArchive();
            }
          }
        })
      }

      const initState = stateObj;

      window.addEventListener('popstate', function(event){
        if ( Object.keys(event.state).length == 0 ) {
          stateObj = initState;
        } else {
          stateObj = event.state;
        }

        updateArchive(true);
      });


      updateArchive = (frompopstate = false) => {
        ajaxIsLoading = true;
        $(archiveBlock).addClass('loading');
        if ( !isInfinite ) {
          smoother.scrollTo(archiveBlock, true, 'top top+=136');
        }


        if ( frompopstate === false ) {
          history.pushState(stateObj, '', stateObj.url);
        }

        const args = {
          paged: stateObj.page,
          base: stateObj.base,
          sort: stateObj.sort,
          postType: stateObj.postType,
          exclude: stateObj.exclude
        };

        if ( stateObj.search !== false ) {
          args.search = stateObj.search;
        } if ( stateObj.hasOwnProperty('postsPerPage') ) {
          args.postsPerPage = stateObj.postsPerPage;
        } if ( stateObj.hasOwnProperty('cardArgs') ) {
          args.cardArgs = stateObj.cardArgs;
        } if ( stateObj.hasOwnProperty('filters') && Object.keys(stateObj.filters).length ) {
          args.filters = stateObj.filters;
        }

        console.log(args);

        $.post(ajaxurl, {
          action: 'cmykpress_get_archive',
          args: args
        }, function(data) {
          // console.log(data);
          try {
            const res = JSON.parse(data);
            console.log(res);

            stateObj.maxPages = res.max_pages;

            if ( isInfinite ) {
              if ( stateObj.page === 1 ) {
                $(archiveFeed).html( res.results );
              } else {
                $(archiveFeed).append(res.results);
              }

              if ( res.max_pages == stateObj.page ) {
                $('#colophon').show();
              } else {
                $('#colophon').hide();
              }

              ScrollTrigger.refresh();

            } else {
              const state = Flip.getState( archiveFeed.get(0).querySelector('li') );
              $(archiveFeed).html( res.results );
              $(archivePagination).html( res.pagination );

              Flip.from(state, {
                absolute: true,
                duration: 0.6,
                onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1}),
                onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0}),
              });
            }
          } catch (err) {
            console.log( err );
          }
        }).always(function(){
          $(archiveBlock).removeClass('loading');
          ajaxIsLoading = false;
        });
      };
    });
  }
  /* END ARCHIVE BLOCK SCRIPTS */

  if ( $('.events-feed').length ) {
    $('.event-filters__type-checkbox').change(function(){
      var tags = []
      $('.event-filters__type-checkbox').each(function(){
        if( $(this).is(":checked") ){
          tags.push("term-" + $(this).val() );
        }

        if ( tags.length == 0 ) {
          $('.events-feed__event').hide();
        } else {
          $('.events-feed__event').hide();
          $('.events-feed__event').each(function(){
            for ( var i = 0; i < tags.length; i++ ) {
              if ( $(this).hasClass( tags[i] ) ) {
                $(this).show();
              }
            }
          });
        }
      });
    })

    $('.events-feed__past__toggle').click(function(){
      $('.events-feed__current').toggleClass('toggled');
      $('.events-feed__past').toggleClass('toggled');
    }).keypress(function(){
      $(this).trigger('click');
    });

    $('.events-feed__navigation-list').not('.past').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            vertical: true
          }
        }
      ]
    });
    $('.events-feed__navigation-list.past').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            vertical: true
          }
        }
      ]
    });
    $('.events-feed__current-slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.events-feed__navigation-list',
      appendArrows: '.events-feed__controls',
      nextArrow: '<button type="button" class="slick-next"><svg width="32px" height="22px" viewBox="0 0 32 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Arrow</title><g stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-16.5 0)"><g transform="translate(-211.000000, -189.000000)"><g transform="translate(211.000000, 190.000000)"><polyline points="35.5 0 47.5 10 35.5 20"></polyline><line x1="47" y1="10" x2="-5.69093384e-14" y2="10"></line></g></g></g></svg></button>',
      prevArrow: '<button type="button" class="slick-prev"><svg width="32px" height="22px" viewBox="0 0 32 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>Arrow</title><g stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(-16.5 0)"><g transform="translate(-211.000000, -189.000000)"><g transform="translate(211.000000, 190.000000)"><polyline points="35.5 0 47.5 10 35.5 20"></polyline><line x1="47" y1="10" x2="-5.69093384e-14" y2="10"></line></g></g></g></svg></button>',
      adaptiveHeight: true
    });

    $('.event-filters__dropdown').change(function(e){
      var index = $( $(this).val() ).data('slick-index');
      $('.events-feed__current-slick').slick('slickGoTo', index);
    });

    $('.events-feed__current-slick').on('afterChange', function(event, slick, currentSlide) {
      console.log( '[data-slick-index="' + currentSlide +'"]' )
      console.log( $('.events-feed__current-slick .slick-slide[data-slick-index="' + currentSlide +'"]').outerHeight() );
      if ( $(window).width() <= 767 ) {
        $('.events-feed__current-slick .slick-list').css('height', $('.events-feed__current-slick .slick-slide[data-slick-index="' + currentSlide +'"]').outerHeight() + 'px');
      }

    });

    $('.events-feed__navigation-list-item a').not('.past').click(function(e) {
      e.preventDefault();
      $('.events-feed__current').removeClass('toggled');
      $('.events-feed__past').removeClass('toggled');
      var target = $(this).attr('href');
      console.log(target);
      var index = $(target).data('slick-index');
      $('.events-feed__current-slick').slick('slickGoTo', index);
    }).keypress(function() {
      $(this).trigger('click');
    });

    $('.events-feed__navigation-list-item a.past').click(function(e) {
      e.preventDefault();
      $('.events-feed__current').removeClass('toggled');
      $('.events-feed__past').removeClass('toggled');
    }).keypress(function() {
      $(this).trigger('click');
    });

    $('.events-feed__controls button svg').click(function(e){
      if ( $(this).parent().hasClass('slick-prev') && $('.events-feed__current .slick-active').data('slick-index') == 0 ) {
        e.preventDefault();
        e.stopPropagation();

        if ( ! $('.events-feed__current').hasClass('toggled') ) {
          $('.events-feed__current').toggleClass('toggled');
          $('.events-feed__past').toggleClass('toggled');
        }

        return false;
      } else if ( $(this).parent().hasClass('slick-next') && $('.events-feed__current').hasClass('toggled') ) {
        e.preventDefault();
        e.stopPropagation();

        $('.events-feed__current').toggleClass('toggled');
        $('.events-feed__past').toggleClass('toggled');

        return false;
      }

    }).keypress(function() {
      $(this).trigger('click');
    });

    if ( $(window).width() <= 767 ) {
      var maxHeight = -1;
      $('.events-feed__current-slick .slick-slide').not('.slick-cloned').each(function(index) {
        if ( index > 0 ) {
          $(this).css('margin-bottom', $(this).prev().height() + 'px');
        }
      });
    }

    $(window).resize(function(){
      if ( $(window).width() <= 767 ) {
        $('.events-feed__current-slick .slick-slide').not('.slick-cloned').each(function(index) {
          if ( index > 0 ) {
            $(this).css('margin-bottom', $(this).prev().height() + 'px');
          }
        });
      } else {
        $('.events-feed__current-slick .slick-slide').not('.slick-cloned').each(function() {
          $(this).css('margin-bottom', '');
        });
      }
    });
  }

  // smooth scrollers
  if ( $('.smooth-scroller').length ) {
    $('.smooth-scroller').click(function(e){
      e.preventDefault();
      console.log("CLICK");
      var target = $(this).attr('href');
      $('html, body').animate({
          scrollTop: $(target).offset().top - 24
       }, 500);
    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  if ( $('.phase-assets-group').length ) {
    $('.phase-assets-group').on('init', function(){
      $(this).hide();
    });

    $('.phase-assets-group').on('setPosition', function () {
    	jbResizeSlider('#' + $(this).attr('id'));
    });

    $('.phase-assets-group').slick({
      mobileFirst: true,
      centerMode: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    });

    $('.phase-assets-group').hide()
  }

  if ( $('.priority-card').length ) {
    $('.priority-card').on('init', function(){
      $(this).hide();
    });

    $('.priority-card').on('setPosition', function () {
    	jbResizeSlider('#' + $(this).attr('id'));
    })

    $('.priority-card').slick({
      mobileFirst: true,
      centerMode: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    });

    $('.priority-card').hide();

    $('.our-solutions__priorities-box').each(function(index){
      if ( index > 0 ) {
        $(this).addClass('mobileHide');
      }
    });

    $('.event-filters__dropdown').change(function(){
      var target = $(this).val();
      console.log(target);
      $('.our-solutions__priorities-box').addClass('mobileHide');
      $(target).removeClass('mobileHide');
      $('.priority-card').hide();
    });

    if ( $(window).width() < 768 ) {
      $('.priority-card').each(function(){
        $(this).appendTo('.our-solutions__priorities-assets');
      });
    }

    $(window).resize(function(){
      if ( $(window).width() < 768 ) {
        $('.priority-card').each(function(){
          $(this).appendTo('.our-solutions__priorities-assets');
        });
      } else {
        $('.priority-card').each(function(){
          $(this).appendTo('.our-solutions__assets');
        });
      }
    });
  }

  if ( $('.our-solutions-section__arrow').length ) {
    $('.our-solutions-section__arrow').click(function(e){
      e.preventDefault();
      var target = $(this).attr('href');
      var selector = '.phase-assets-group';
      console.log(target);
      console.log(selector);
      $('.our-solutions-section__arrow').siblings('.active').removeClass('active');
      $(this).addClass('active');
      if ( $(selector + '.active').length ) {
        $(selector + '.active').fadeOut(400, function(){
          $(this).removeClass('active');
          $(target).addClass('active');
          $(target).fadeIn(400, function(){
            $(this).slick('setPosition');
          });
          $(this).slick('setPosition');
        });
      } else if ( $('.priority-card.active').length ) {
        $('.our-solutions__priorities-box h3.active').removeClass('active');
        $('.priority-card.active').fadeOut(400, function(){
          $(this).removeClass('active');
          $(target).addClass('active');
          $(target).fadeIn();
        });
      } else {
        $(target).addClass('active');
        $(target).fadeIn(400, function(){
          $(this).slick('setPosition');
        });
        $(target).slick('setPosition');
      }
    }).keypress(function(){
      $(this).trigger('click');
    })

  }

  if ( $('a.priority-trigger').length ) {
    $('a.priority-trigger').click(function(e){
      e.preventDefault();
      var target = $(this).attr('href');

      $('.our-solutions__priorities-box h3').removeClass('active');
      $(this).parent().addClass('active');

      if ( $('.phase-assets-group.active').length ) {
        $('.phase-assets-group.active').fadeOut(400, function(){
          $('.our-solutions-section__arrow.active').removeClass('active');
          $(this).removeClass('active');
          $(target).addClass('active');
          $(target).fadeIn();
          if ( $(window).width <= 767 ) {
            $('html, body').animate({
                scrollTop: $(target).offset().top - 24
             }, 500);
          }
        });
      } else if ( $('.priority-card.active').length ) {
        $('.priority-card.active').fadeOut(400, function(){
          $(this).removeClass('active');
          $(target).addClass('active');
          $(target).fadeIn();
          if ( $(window).width <= 767 ) {
            $('html, body').animate({
                scrollTop: $(target).offset().top - 24
             }, 500);
          }
        });
      } else {
        $(target).addClass('active');
        $(target).fadeIn(500, function(){
          $(target).slick('setPosition');
        });
        $(target).slick('setPosition');
        if ( $(window).width <= 767 ) {
          $('html, body').animate({
              scrollTop: $(target).offset().top - 24
           }, 500);
        }

      }

    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  if ( $('.our-solutions__priorities-box-list').length ) {
    $('.our-solutions__priorities-box-list').hide();
    $('.priority-box-solutions-list-toggle').click(function(){
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    }).keypress(function(){
      $(this).trigger('click');
    });
  }

  if ( $('.accordionRow').length || $('.acContent').length ) {
    $('.acTitle').each(function(){
      const thisRef = $(this);
      let needsID = true;
      $('*', $(thisRef).next()).each(function(){
        if ( $(this).attr('id') !== undefined ) {
          if ( needsID ) {
            $(thisRef).attr('key', $(this).attr('id') + '-accordionTab');
          }
        }
      });
    });

    $('.acContent').hide();
    $('.acTitle').unbind();
    $('.acTitle').click(function(){
      if ( $('.sequential-accordions').length ) {
        if ( $(this).parent().hasClass('active') ) {
          $(this).parent().removeClass('active');
        } else {
          if ( $('.wp-block-wp-beb-accordion.active').length ) {
            $('.wp-block-wp-beb-accordion.active').find('.acContent').slideUp();
            $('.wp-block-wp-beb-accordion.active').removeClass('active');
          }

          $(this).parent().addClass('active');
        }
      }

      $(this).next().slideToggle();
      $(this).toggleClass('active');

      window.location.hash = $(this).attr('key');
      dataLayer.push({'event': 'pagination-click','pagination-title': $(this).text() });
    }).keypress(function(){
      $(this).trigger('click');
    });

    var hash =  window.location.hash.substr(1);
    if ( hash != '' ) {
      if ( hash.includes('-accordionTab') ) {
        const target = $('.acTitle[key="' + hash + '"]').siblings('.acContent');

        if ( $(target).length ) {
          target.parent().addClass('active');
          
          const title = $(target).siblings('.acTitle');
          $(title).addClass('active');
          $(target).show();

          window.scrollTo(0,0);
          $('html, body').animate({
              scrollTop: title.offset().top - 24
           }, 500);
        }
      } else if ( $('.sequential-accordions').length ) {
        const target = $('.acTitle').eq(0);
        target.siblings('.acContent').show();
        target.parent().addClass('active');
      }
    } else if ( $('.sequential-accordions').length ) {
      const target = $('.acTitle').eq(0);
      target.siblings('.acContent').show();
      target.parent().addClass('active');
    }
  }


  if ( $('.wp-block-tabbed-carousel').length ) {

    if ( $('.wp-block-tabbed-carousel').find('.tc-vi-globes').length ) {
      $('.wp-block-tabbed-carousel').find('.tc-vi-globes svg').addClass('needs-anim');
    }

    var hash =  window.location.hash.substr(1);
    console.log('hash', hash);

    jQuery('.stage-tab-link').click(function(){
      jQuery('.stage-tab-link').removeClass('active');
      jQuery(this).addClass('active');
      var key = jQuery(this).attr('key');
      window.location.hash = key;
      jQuery('.stage-tab-descriptions .stage-tab-desc').fadeOut();
      jQuery('.mobile-current-tab span').html(jQuery(this).html());

      var title = jQuery(this).text();
      dataLayer.push({'event': 'pagination-click','pagination-title': title });

      setTimeout(function(){
        console.log(jQuery('.stage-tab-descriptions .stage-tab-desc[key="' + key +'"]'));
        jQuery('.stage-tab-descriptions .stage-tab-desc[key="' + key +'"]').fadeIn().css('display', 'flex');
        if ( jQuery('.stage-tab-descriptions .stage-tab-desc[key="' + key +'"]').find('.tc-vi-globes').length ) {
          jQuery('.stage-tab-descriptions .stage-tab-desc[key="' + key +'"]').find('.tc-vi-globes svg').each(function(index){
            const thisRef = $(this);
            setTimeout(function(){
              thisRef.addClass('active');
            }, 30 * index);
          });
        }

      }, 400);
      if(jQuery(window).width() <= 767){
        jQuery('.stage-tab-cont').slideToggle();
        jQuery('.mobile-current-tab').toggleClass('currently-active');
      }

    });

    jQuery('.mobile-current-tab').click(function(){
      jQuery('.stage-tab-cont').slideToggle();
      jQuery(this).toggleClass('currently-active');
    });

    if ( hash != '' ) {
      $('#tab-' + hash).click();
      var target = $('#tab-' + hash);
      if ( $(target).length ) {
        $('html, body').animate({
            scrollTop: $(target).offset().top - 24
         }, 500);
      }

    }
  }
  if ( $('.ccr-trigger').length ) {
    $('.ccr-trigger').click(function(e) {
      e.preventDefault();
      $($(this).attr('href')).toggleClass('active');
    }).on('keypress', function(){
      $(this).trigger('click');
    });

    $('.wp-block-ccr svg').addClass('fadeout');

    $(window).on('scroll', function() {
      if ( ($(window).scrollTop() + ($(window).height() / 2)) > $('.wp-block-ccr').offset().top ) {
        $('.wp-block-ccr svg').addClass('fadein');
      }
    });
  }

  if ( $('.biocelerate-carousel__slick').length ) {
    $('.biocelerate-carousel__slick').slick({
      arrows: false,
      fade: true
    });

    $('.biocelerate-carousel__slick').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      const nav = $(this).parent().parent().find('.biocelerate-carousel__item-link');
      nav.removeClass('active');
      nav.eq(nextSlide).addClass('active');
    });

    $('.biocelerate-carousel__item-link').on('click', function(e){
      e.preventDefault();
      const target = $(this).attr('href');
      $('.biocelerate-carousel__slick').slick('slickGoTo', $(target).index('.biocelerate-carousel__slide'));
    });
  }

  if ( $('.gt-fixed__button').length ) {
    $('.gt-fixed__button').on('click', function(){
      $(this).attr('aria-expanded', ($(this).attr('aria-expanded') == 'true') ? 'false' : 'true');
      $('.gt-fixed__pull').toggleClass('active');
    }).on('keypress', function() {
      $(this).trigger('click');
    });
  }

  if ( $('.MOA_Group_Button').length ) {
    $('.MOA_Group_Button').on('click', function(e){
      e.preventDefault();
      $(this).parent().toggleClass('active');
      const group = $(this).data('group');
      $('.MOA_Mobile_Button#MOA_MobileButton_' + group).trigger('click');
    }).on('keypress', function(){
      $(this).trigger('click');
    });
  }

  if ( $('.MOA_Mobile_Button').length ) {
    $('.tc-moa-graphic__group').hide();
    $('.MOA_Mobile_Button').on('click', function(e){
      e.preventDefault();
      const group = $(this).attr('id').split('_');
      const target = $('#tc-moa-group__' + group[group.length - 1]);
      const line = $('#MOA_MobileLine_' + group[group.length - 1]);
      if ( target.hasClass('active') ) {
        target.slideUp();
        target.removeClass('active');
        line.removeClass('active');
      } else {
        if ( $('.tc-moa-graphic__group.active').length == 0 ) {
          target.slideDown();
          target.addClass('active');
          line.addClass('active');
        } else {
          $('#MOA_MobileLines rect').removeClass('active');
          $('.tc-moa-graphic__group.active').slideUp(400, function(){
            $(this).removeClass('active');
            target.slideDown();
            target.addClass('active');
            line.addClass('active');
          });
        }

      }
    }).on('keypress', function(){
      $(this).trigger('click');
    });
  }

  if ( $('.tc-pvao').length ) {
    $('.tc-pvao').each(function(){
      const list = $(this).find('.tc-pvao__sections__list');
      const controls = $(this).find('.tc-pvao__sections__controls');
      const container = $(this).find('.tc-pvao__sections');
      list.slick({
        infinite: false,
        arrows: true,
        appendArrows: controls,
        adaptiveHeight: true,
        fade: true,
        'prevArrow': '<button type="button" class="slick-prev"><span class="icon"></span>Previous Step</button>',
        'nextArrow': '<button type="button" class="slick-next">Next Step<span class="icon"></span></button>',
      });

      list.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        if ( $('.tc-pvao__section.active').length ) {
          $( '#' + $('.tc-pvao__section.active').attr('for') + '-modal' ).removeClass('active');
          $('.tc-pvao__section.active').removeClass('active');
        }
        $('.pvao-button.active').removeClass('active');
        const next = list.find('.slick-slide[data-slick-index="' + nextSlide +'"]');
        const trigger = next.attr('for');
        $('#' + trigger).addClass('active');
        $('#' + trigger + '-mobile').addClass('active');
        next.addClass('active');
      });

      container.hide();
      $(this).find('.pvao-button').each(function(){
        const el = $(this).find('path').get( $(this).find('path').length - 1 );
        const parent = el.parentNode;
        const clone = el.cloneNode();
        clone.classList.add('hover');
        parent.insertBefore(clone, el.nextSibling);

        $(this).on('click', function(e){
          e.preventDefault();
          const target = $(this).attr('href');
          // console.log($(target));
          // if ( $(target).hasClass('active') ) {
          //   $(target).find('.tc-pvao__section__modal').removeClass('active');
          //   $(target).slideUp().removeClass('active');
          //   $(this).removeClass('active');
          // } else {
          //   if ( $('.tc-pvao__section.active').length ) {
          //     $('.tc-pvao__section.active').find('.tc-pvao__section__modal').removeClass('active');
          //     $('.tc-pvao__section.active').removeClass('active').slideUp(500, function(){
          //       $(target).slideDown().addClass('active');
          //     });
          //   } else {
          //     $(target).slideDown().addClass('active');
          //   }
          //   $('.pvao-button.active').removeClass('active');
          //   $(this).addClass('active');
          // }

          const targetphase = $(target).attr('for');
          if ( $(target).hasClass('active') ) {
            container.fadeOut().addClass('active');
            $(target).removeClass('active');
            $( '#' + targetphase ).removeClass('active');
            $( '#' + targetphase + '-mobile' ).removeClass('active');
            $( '#' + targetphase + '-modal' ).removeClass('active');
          } else {
            $('.pvao-button').removeClass('active');
            $( '#' + targetphase ).addClass('active');
            $( '#' + targetphase + '-mobile' ).addClass('active');
            if ( $('.tc-pvao__section.active').length ) {
              $( '#' + $('.tc-pvao__section.active').attr('for') + '-modal' ).removeClass('active');
              $('.tc-pvao__section.active').removeClass('active');
            } else {
              container.fadeIn(500, function(){
                list.slick('setPosition');
              }).addClass('active');
              setTimeout(function(){
                list.slick('setPosition');
              }, 50);
            }

            $(target).addClass('active');
            list.slick('slickGoTo', $(target).data('key'));
          }
        }).on('keypress', function(){
          $(this).trigger('click');
        });
      });
    });

    $('.tc-pvao__section').each(function(){
      // $(this).hide();

      if ( $(this).find('.tc-pvao__section__title.button').length ) {
        const target = $(this).attr('for');
        $('#' + target).addClass('has-tools');
        $('#' + target + '-mobile').addClass('has-tools');
      }
    });

    $('.tc-pvao__section__modal').each(function(){
      const id = $(this).attr('id');
      console.log(id);
      const modalref = $(this);
      if ( $('a[href="#' + id + '"]').length ) {
        $('a[href="#' + id + '"]').each(function(){
          $(this).on('click', function(e){
            e.preventDefault();
            modalref.addClass('active');
          });
        });
      }

      $(this).find('.tc-pvao__section__modal__close').on('click', function(){
        modalref.removeClass('active');
      }).on('keypress', function(){
        $(this).trigger('click');
      });
    });

    if ( window.location.hash.substr(1) != '' ) {
      $('#' + window.location.hash.substr(1) ).trigger('click');
    }
  }
  // end PVAO scripts

  // dropdowns
  if ( $('.cmykpress-dropdown').length ) {
    $('.cmykpress-dropdown').each(function(){
      const thisRef = this;
      const toggle = $(this).find('.cmykpress-dropdown__toggle');
      const wrapper = $(this).find('.cmykpress-dropdown__inner');
      const dropdown = $(this).find('.cmykpress-dropdown__dropdown');
      let isAnimating = false;
      
      $(dropdown).css({
        width: 'auto'
      });
      
      $(wrapper).css({
        'width': Math.round(dropdown.width() + 16) + 'px'
      });
      
      $(dropdown).css({
        width: '100%'
      });
      
      const openDropdown = (e) => {
        $(thisRef).addClass('open');
        $(toggle).attr('aria-expanded', 'true');
        
        $(dropdown).css({
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
        gsap.to(dropdown, {
          clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
          ease: 'power2.inOut',
          overwrite: true
        });
      };
      
      const closeDropdown = (e) => {
        $(thisRef).removeClass('open');
        $(toggle).attr('aria-expanded', 'false');
        
        gsap.to(dropdown, {
          clipPath: 'polygon(0 0, 100% 0, 100% 0%, 0% 0%)',
          ease: 'power2.inOut',
          overwrite: true,
          onComplete: function(){
            $(dropdown).css({
              'visibility': 'hidden',
              'pointer-events': 'none'
            });
          }
        });
      };
      
      toggle.on('click', function(e){        
        if ( $(this).attr('aria-expanded') == 'true' ) {
          closeDropdown(e);
        } else {
          openDropdown(e);
        }
      });
      
      if ( window.matchMedia('pointer: fine') ) {
        $(this).on('mouseenter', function(e){
          openDropdown(e);
        });
        
        $(this).on('mouseleave', function(e){
          closeDropdown(e);
        });
      }
      
      if ( $(this).find('.cmykpress-dropdown__input-input') ) {
        console.log($(this).find('.cmykpress-dropdown__input-input'));
        $(this).find('.cmykpress-dropdown__input-input').on('change', function(){
          if ( $(this).is(':checked') ) {
            $(toggle).text( $(this).siblings('.cmykpress-dropdown__input__label').text() );
          }
        });
      }
    });
  }

  // V&I scripts

  if ( $('.tc-gallery').length ) {
    $('.tc-gallery').each(function(){
      $(this).slick({
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        dots: true,
        swipe: false,
        adaptiveHeight: true,
        fade: true
      });
    });
  }

  if ( $('.tc-vi-piechart').length ) {
    $('.tc-vi-piechart').each(function(){
      const piedata = {};
      const piecolors = [];
      const pielabels = {};
      let total = 0;
      $('.tc-vi-piechart__table tbody tr').each(function(){
        const label = $(this).data('label');
        const value = parseFloat( $(this).data('value') );
        console.log(value);
        piedata[label] = value;
        piecolors.push( $(this).data('color') );
        total += value;
        pielabels[label] = $(this).data('percent');
      });

      // $('.tc-vi-piechart__table tbody tr').each(function(){
      //   const label = $(this).data('label');
      //   const value = parseFloat( $(this).data('value') );
      //   pielabels[label] = Math.floor(  (value / total) * 100 );
      // });


        // set the dimensions and margins of the graph
        const width = 320,
            height = 320,
            margin = 0;

        // The radius of the pieplot is half the width or half the height (smallest one). I subtract a bit of margin.
        const radius = Math.min(width, height) / 2 - margin

        // append the svg object to the div called 'my_dataviz'
        const svg = d3.select( $(this).find('.tc-vi-piechart__pie__container').get(0)  )
          .append("svg")
            .attr("width", width)
            .attr("height", height)
            .attr('viewBox', '0 0 ' + width + ' ' + height)
          .append("g")
            .attr("transform", `translate(${width / 2}, ${height / 2})`);

        // set the color scale
        const color = d3.scaleOrdinal()
          .range( piecolors );

        // Compute the position of each group on the pie:
        const pie = d3.pie()
          .value(function(d) {return d[1]}).sort(null)
        const data_ready = pie(Object.entries(piedata));
        // Now I know that group A goes from 0 degrees to x degrees and so on.

        // shape helper to build arcs:
        const arcGenerator = d3.arc()
          .innerRadius(0)
          .outerRadius(radius)

        // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
        svg
          .selectAll('mySlices')
          .data(data_ready)
          .join('path')
            .attr('d', arcGenerator)
            .attr('fill', function(d){ return(color(d.data[0])) })
            .attr("stroke", "white")
            .style("stroke-width", "3px")
            .style("opacity", 1)

        // Now add the annotation. Use the centroid method to get the best coordinates
        svg
          .selectAll('mySlices')
          .data(data_ready)
          .join('text')
          .text(function(d){ return pielabels[d.data[0]] + '%'; })
          .attr("transform", function(d) { return `translate(${arcGenerator.centroid(d)})`})
          .style("text-anchor", "middle")
          .style("font-size", 16)
          .style('stroke', 'none')
          .style('fill',' white')
          .attr('font-family', 'acumin-pro, sans-serif')
          .attr('font-weight', '700');

      const table = $(this).find('.tc-vi-piechart__table');
      const aux = $(this).find('.tc-vi-piechart__pie__aux');
      const paths = $(this).find('path');
      const chart = $(this).find('svg');
      $(this).find('path').each(function(index){
        $(this).attr('tabindex', 0);
        $(this).on('click', function(){
          if ( $(table).find('tbody tr').eq(index).hasClass('focused') ) {
            paths.removeClass('focused');
            $(chart).removeClass('focused');
            $(table).removeClass('focused');
            $(table).find('tbody tr').removeClass('focused');
            aux.fadeOut();
          } else {
            $(paths).removeClass('focused');
            $(chart).addClass('focused');
            $(table).addClass('focused');
            $(this).addClass('focused');
            $(table).find('tbody tr').removeClass('focused');
            $(table).find('tbody tr').eq(index).addClass('focused');
            if ( $(table).find('tbody tr').eq(index).data('content') == '' ) {
              aux.fadeOut();
            } else {
              aux.html( $(table).find('tbody tr').eq(index).data('content') );
              aux.css('border-color', $(table).find('tbody tr').eq(index).data('color'));
              aux.fadeIn();
            }


          }

        }).on('keypress', function(){
          $(this).trigger('click');
        });
      });
    });
  }

  var isAnimating = false;
    if ( $('.tc-vi-statistics').length ) {
      $('.tc-vi-statistics').each(function(){

        const buttons = $(this).find('.is-button');
        buttons.on('mousemove', function(){
          if(isAnimating){

          }else{
          const thisRef = $(this);
          if ( !thisRef.hasClass('active') ) {

            buttons.removeClass('active');
            thisRef.addClass('active');

            if ( $('.tc-vi-statistics__messages .active').length ) {
              isAnimating = true;
              $('.tc-vi-statistics__messages .active').fadeOut(200, function(){
                $( '#' + thisRef.attr('aria-controls') ).addClass('active').fadeIn();
                thisRef.attr('aria-expanded', 'true');
                isAnimating = false;
              }).removeClass('active');
            } else {
              $( '#' + thisRef.attr('aria-controls') ).addClass('active').fadeIn();
              thisRef.attr('aria-expanded', 'true');
            }
          }
        }
        }).on('keypress', function(){
          $(this).trigger('click');
        });
        buttons.on('mouseleave', function(){

        });
      });

    }

  // gallery
  if ( $('.wp-block-gallery').length ) {
    $('.wp-block-gallery').each(function(){
      gutenbergSlickify(this);
    });
  }
  
  if ( $('.logo-ticker').length ) {
    $('.logo-ticker').each(function() {
      const strip = $(this).find('.logo-ticker__strip');
      const thisRef = this;
      let oldSize = $(window).width();
      let stripW = strip.width();
      let curW = stripW;
      let clones = 0;
      let clonesArr = [];
      
      // Check if Mobile and stop animation if true
      if (isMobile) {
        console.log('Stop animation');
        return; // Exit the function if mobile
      }
      
      let speed = isMobile ? stripW / 24 : stripW / 50;
      console.log('working!!');
      do {
        curW += stripW;
        clones++;
        const clone = strip.clone(false);
        $(this).append(clone);
        
        gsap.set(clone, {
          x: ( clones * 100 ) + '%'
        });
        
        clonesArr.push(clone);
      } 
      while ( curW && curW !== 0 && curW < oldSize * 2 );
      
      const loop = gsap.timeline({
        repeat: -1
      });
      
      loop.to(strip, {
        x: '-=100%',
        ease: 'linear',
        duration: () => {
          return speed;
        }
      });
      
      for ( let i = 0; i < clonesArr.length; i++ ) {
        loop.to(clonesArr[i], {
          x: '-=100%',
          ease: 'linear',
          duration: () => {
            return speed;
          }
        }, '0');
      }
      
      $(window).on('resize', function(){
        speed = isMobile ? stripW / 13 : stripW / 30
        if ( oldSize !== $(window).width() && oldSize < $(window).width() ) {
          const newW = $(window).width();
          if ( newW * 2 > curW ) {
            while ( curW && curW !== 0 && curW < newW * 2 ) {
              curW += stripW;
              clones++;
              const clone = strip.clone(false);
              $(thisRef).append(clone);
              
              gsap.set(clone, {
                x: ( clones * 100 ) + '%'
              });
              
              loop.to(clone, {
                x: '-=100%',
                ease: 'linear',
                duration: () => {
                  return speed;
                }
              }, '0');
              
              clonesArr.push(clone);
            }
            
            oldSize = newW;
          }
        }
        if ( oldSize !== $(window).width() && oldSize > $(window).width() ) {
          console.log('decreased window size');
          if( isMobile ){
            console.log('updated to mobile');
          }
        }
      });
    });
  }
});
// end document ready

$(window).scroll(function(){
  var scrollY = $(window).scrollTop();
  if ( scrollY >= 80 ) {
    $('.site-header__hamburger').addClass('scrolled');
  } else {
    $('.site-header__hamburger').removeClass('scrolled');
  }
});

jQuery.fn.shake = function(interval,distance,times){
   interval = typeof interval == "undefined" ? 100 : interval;
   distance = typeof distance == "undefined" ? 10 : distance;
   times = typeof times == "undefined" ? 3 : times;
   var jTarget = $(this);
   jTarget.css('position','relative');
   for(var iter=0;iter<(times+1);iter++){
      jTarget.animate({ left: ((iter%2==0 ? distance : distance*-1))}, interval);
   }
   return jTarget.animate({ left: 0},interval);
}

jQuery.fn.isVScrollable = function () {
    return this[0].scrollHeight > this[0].clientHeight;
};

function ajaxPushState(url, title) {
  var parser = document.createElement('a');
  parser.href = url;
  var path = parser.pathname;

  if (history.pushState) {
    window.history.pushState("object or string", title + " - Transcelerate", path);
  } else {
    document.location.href = path;
  }
}

function loremIpsum(len) {
  var lorem = [
    "<p><span>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Itaque sensibus rationem adiunxit et ratione effecta sensus non reliquit. Num igitur utiliorem tibi hunc Triarium putas esse posse, quam si tua sint Puteolis granaria?</span></p>",
    "<p><span>Nos cum te, M. Duarum enim vitarum nobis erunt instituta capienda. Quae cum dixisset paulumque institisset, Quid est? Quem Tiberina descensio festo illo die tanto gaudio affecit, quanto L. Sin laboramus, quis est, qui alienae modum statuat industriae? Sed audiamus ipsum: Compensabatur, inquit, tamen cum his omnibus animi laetitia, quam capiebam memoria rationum inventorumque nostrorum. Sed in rebus apertissimis nimium longi sumus. Virtutis, magnitudinis animi, patientiae, fortitudinis fomentis dolor mitigari sovar. Alterum significari idem, ut si diceretur, officia media omnia aut pleraque servantem vivere.</span></p>",
    "<p><span>Certe nihil nisi quod possit ipsum propter se iure laudari. Beatum, inquit. Hanc quoque iucunditatem, si vis, transfer in animum; De malis autem et bonis ab iis animalibus, quae nondum depravata sint, ait optime iudicari. Rhetorice igitur, inquam, nos mavis quam dialectice disputare? Sed quid minus probandum quam esse aliquem beatum nec satis beatum? Nam quid possumus facere melius?</span></p>",
  ];

  var sb = "";
  for ( var i = 0; i < len; i++ ) {
    sb += lorem[i % lorem.length];
  }

  return sb;
}

function jbResizeSlider(selector){
	$slickSlider = $(selector);
	$slickSlider.find('.slick-slide').height('auto');

	var slickTrack = $slickSlider.find('.slick-track');
	var slickTrackHeight = $(slickTrack).height();

	$slickSlider.find('.slick-slide').css('height', slickTrackHeight + 'px');
}

$('.tc-init-form iframe #rc-anchor-container').css('border: 1px solid #FA8E23 !important');
$('.tc-init-form iframe #rc-anchor-container').css('background: transparent');
$('.tc-init-form iframe #rc-anchor-container .recaptcha-checkbox-border').css('border: 2px solid #FA8E23 !important');

/*
 * Functions
 ***************************/
 function gutenbergSlickify(el) {
   const count = $(el).find('figure').length;

   const captions = [];

   const countFigures = $(el).find('figure').length;
   $(el).find('figure').each(function(index){
     $(this).css({
       'z-index': countFigures - index
     });
     if ( $(this).find('figcaption').length ) {
       $(this).addClass('has-caption');
       captions.push( $(this).find('figcaption').clone(true) );
       $(this).find('figcaption').remove();
     } else {
       captions.push('<div style="height:10px;"></div>');
     }
   });

   $(el).find('.blocks-gallery-item').each(function(){
     $(this).addClass('slick-gallery-item').removeClass('blocks-gallery-item');
   });

   $(el).find('.blocks-gallery-item__caption').each(function(){
     $(this).addClass('slick-gallery-item__caption').removeClass('blocks-gallery-item__caption');
   });

   $(el).addClass('slick-gallery-grid').removeClass('blocks-gallery-grid');

   // $(el).parent().addClass('slick-gallery').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> of <b>' + count +'</b></div></div>');

   $(el).removeClass('wp-block-gallery').wrap('<div></div>').wrap('<div></div>');
   const parent = $(el).parent();
   const outerParent = parent.parent();
   outerParent.addClass('slick-gallery').addClass('alignwide').removeClass('wp-block-gallery').append('<div class="slick-gallery-nav"><div class="slick-gallery-nav__inner"><div class="slick-gallery-nav__count"><b><span class="slick-gallery-nav__count__cur">1</span></b> / <b>' + count +'</b></div><div class="slick-gallery-nav__captions-outer"><div class="slick-gallery-nav__captions"></div></div></div>');

   parent.addClass('slick-gallery-container');


   const nav = $(outerParent).find('.slick-gallery-nav');
   const captionsContainer = nav.find('.slick-gallery-nav__captions');
   for (let i = 0; i < captions.length; i++) {
     captionsContainer.append( captions[i] );
   }

   captionsContainer.slick({
     adaptiveHeight: true,
     arrows: false,
     swipe: false,
     fade: true,
     infinite: false,
     speed: 1000
   });

   $(el).slick({
     adaptiveHeight: true,
     prevArrow: prevArrow,
     nextArrow: nextArrow,
     appendArrows: nav,
     asNavFor: captionsContainer,
     centerMode: true,
     centerPadding: '76px',
     infinite: false,
     speed: 1000,
     responsive: [
       {
         breakpoint: 768,
         settings: {
           centerPadding: '34px'
         }
       }
     ]
   });

   $(el).on('beforeChange', function(event, slick, currentSlide, nextSlide){
     nav.find('.slick-gallery-nav__count__cur').text(nextSlide + 1);
   });
 }

 /*
 * Window Resize
 ***************************/
$(window).resize(function(){
  windowWidth = $(window).width();
  windowHeight = $(window).height();
  windowScrollHeight = document.querySelector('body').scrollHeight;
  isMobile = ( windowWidth <= mobileBreakpoint );
}); // end window resize functions




if ( $('.logo-ticker').length ){
  console.log('please work this time');
}

  console.log('working End of Scripts tags!!');


